module.exports = __webpack_public_path__ + "img/main-columns.44c28caa.svg";